import { ContributionFormatting } from '@/api/project';

const DEFAULT_LOCALE = 'fi-FI';
const DEFAULT_NUMBER_OPTIONS: Intl.NumberFormatOptions = {
    style: 'currency',
    maximumFractionDigits: 0,
};

export type Options = Intl.NumberFormatOptions & { locale?: string | string[] };

const formatCurrency =
    (currency: string) => (value: number, options?: Options) => {
        return new Intl.NumberFormat(options?.locale || DEFAULT_LOCALE, {
            ...DEFAULT_NUMBER_OPTIONS,
            currency,
            ...options,
        }).format(value);
    };

const formatNone = (value: number, options?: Options) =>
    new Intl.NumberFormat(options?.locale || DEFAULT_LOCALE, {
        maximumFractionDigits: 2,
        ...options,
    }).format(value);

const formatPcs = (value: number, options?: Options) => {
    const formatted = formatNone(value, options);

    return `${formatted} pcs`;
};

export const getContributionFormatter = (format: ContributionFormatting) => {
    if (format === 'eur') {
        return formatCurrency('EUR');
    }

    if (format === 'usd') {
        return formatCurrency('USD');
    }

    if (format === 'pcs') {
        return formatPcs;
    }

    return formatNone;
};

export const getContributionInputAddon = (format: ContributionFormatting) => {
    if (format === 'eur') {
        return '€';
    }

    if (format === 'usd') {
        return '$';
    }

    if (format === 'pcs') {
        return 'PCS';
    }

    return '';
};
